module.exports = __webpack_public_path__ + "img/hero_jp.c46a442.jpg";